import styled from 'styled-components';
const FailureStyled = styled.div`
  .table-wrapper {
    .table-content {
      padding: 0;
    }
  }
`;
export default FailureStyled;
